import React from "react";

import styled from "styled-components";

// import component
import TagComponent from "../../components/TagComponent";

const WorkDetailPagesSectionOne = () => {
  return (
    <WorkDetailPagesSectionOneStyled className='container'>
      <div className='left container'>
        <div className='breadcrumb-container'>
          <div className='paragraph-small regular first'>Works</div>
          <div>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.83811 2.22922C5.14374 1.92359 5.63926 1.92359 5.94488 2.22922L11.1623 7.44661C11.4679 7.75224 11.4679 8.24776 11.1623 8.55339L5.94488 13.7708C5.63926 14.0764 5.14374 14.0764 4.83811 13.7708C4.53248 13.4652 4.53248 12.9696 4.83811 12.664L9.50211 8L4.83811 3.336C4.53248 3.03037 4.53248 2.53485 4.83811 2.22922Z'
                fill='#CCCCCC'
              />
            </svg>
          </div>
          <div
            className='paragraph-small regular second'
            id='worksDetail-breadcrumbTitle'>
            MJA UNILEVER
          </div>
        </div>
        <div
          className='project-title display-large'
          id='worksDetail-projectTitle'>
          MJA UNILEVER
        </div>
        <div
          className='desc-container paragraph-medium regular'
          id='worksDetail-shortSummary'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa
          mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,
          mattis ligula consectetur, ultrices mauris.{' '}
        </div>
        <div className='tagging'>
          <div className='tag-work tag-container'>
            <div className='top title paragraph-medium'>WHAT WE DO</div>
            <div className='bottom' id='worksDetail-projectTags'>
              <TagComponent text='Software Development' theme='primary' />
              <TagComponent text='IT Security' theme='primary' />
              <TagComponent text='IT Security' theme='primary' />
            </div>
          </div>
          <div className='year tag-container'>
            <div className='top title paragraph-medium'>YEAR</div>
            <div className='bottom' id='worksDetail-projectYear'>
              2045
            </div>
          </div>
        </div>
        <div className='media-sosial'>
          <div className='share paragraph-medium regular'>SHARE</div>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            id='worksDetail-share-whatsapp'>
            <path
              d='M17.5594 14.9119C17.4049 15.6762 16.9912 16.3637 16.3882 16.8581C15.7851 17.3525 15.0298 17.6234 14.25 17.625C12.1622 17.6227 10.1604 16.7923 8.68405 15.316C7.20768 13.8396 6.37728 11.8379 6.37505 9.74998C6.37666 8.9702 6.64757 8.21491 7.14196 7.61188C7.63634 7.00884 8.32385 6.59509 9.08817 6.4406C9.3298 6.39279 9.58044 6.42559 9.80162 6.53398C10.0228 6.64237 10.2023 6.82035 10.3125 7.0406L11.3888 9.19685C11.4771 9.37399 11.517 9.57127 11.5047 9.7688C11.4924 9.96632 11.4281 10.1571 11.3185 10.3219L10.5197 11.52C10.931 12.3775 11.6225 13.069 12.48 13.4803L13.6782 12.6815C13.8429 12.5719 14.0337 12.5077 14.2312 12.4953C14.4288 12.483 14.626 12.523 14.8032 12.6112L16.9594 13.6875C17.1797 13.7977 17.3577 13.9772 17.466 14.1984C17.5744 14.4196 17.6072 14.6702 17.5594 14.9119ZM22.125 12C22.1254 13.7343 21.6803 15.4397 20.8323 16.9526C19.9843 18.4655 18.7619 19.7352 17.2823 20.64C15.8027 21.5448 14.1155 22.0544 12.3824 22.1199C10.6493 22.1854 8.92841 21.8046 7.38474 21.014L4.34442 22.0312C4.01345 22.1428 3.6579 22.1597 3.31784 22.08C2.97779 22.0003 2.66675 21.8272 2.41978 21.5802C2.17281 21.3333 1.99973 21.0222 1.92005 20.6822C1.84037 20.3421 1.85725 19.9866 1.9688 19.6556L2.98224 16.6153C2.28632 15.2521 1.9085 13.7489 1.87718 12.2187C1.84585 10.6885 2.16185 9.17115 2.8014 7.78066C3.44095 6.39017 4.38741 5.16276 5.56962 4.19072C6.75184 3.21868 8.13904 2.5273 9.62693 2.16857C11.1148 1.80985 12.6647 1.7931 14.16 2.1196C15.6553 2.44609 17.0571 3.10734 18.26 4.05361C19.4629 4.99988 20.4357 6.20655 21.1052 7.5829C21.7746 8.95925 22.1233 10.4695 22.125 12ZM19.875 12C19.8746 10.7921 19.5963 9.60042 19.0616 8.51726C18.5269 7.43411 17.7503 6.48847 16.7917 5.7535C15.8331 5.01852 14.7182 4.51392 13.5334 4.27871C12.3486 4.04351 11.1256 4.08402 9.95894 4.3971C8.79229 4.71018 7.7133 5.28745 6.80543 6.08424C5.89757 6.88103 5.18517 7.87599 4.72334 8.99214C4.26152 10.1083 4.06264 11.3157 4.14211 12.521C4.22157 13.7264 4.57725 14.8972 5.18161 15.9431C5.26149 16.081 5.31116 16.2343 5.32732 16.3929C5.34348 16.5514 5.32577 16.7116 5.27536 16.8628L4.34442 19.6556L7.13724 18.7247C7.25212 18.6864 7.3724 18.6668 7.49349 18.6665C7.69107 18.6669 7.88508 18.7193 8.05599 18.8184C9.2532 19.5112 10.6117 19.8764 11.9949 19.8773C13.3781 19.8782 14.7371 19.5147 15.9353 18.8235C17.1334 18.1323 18.1283 17.1378 18.8199 15.9399C19.5115 14.7421 19.8755 13.3832 19.875 12Z'
              fill='#3182FF'
            />
          </svg>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            id='worksDetail-share-linkedin'>
            <path
              d='M20.25 1.875H3.75C3.25272 1.875 2.77581 2.07254 2.42417 2.42417C2.07254 2.77581 1.875 3.25272 1.875 3.75V20.25C1.875 20.7473 2.07254 21.2242 2.42417 21.5758C2.77581 21.9275 3.25272 22.125 3.75 22.125H20.25C20.7473 22.125 21.2242 21.9275 21.5758 21.5758C21.9275 21.2242 22.125 20.7473 22.125 20.25V3.75C22.125 3.25272 21.9275 2.77581 21.5758 2.42417C21.2242 2.07254 20.7473 1.875 20.25 1.875ZM19.875 19.875H4.125V4.125H19.875V19.875ZM10.5 16.5V11.625C10.5002 11.3912 10.5733 11.1633 10.709 10.9729C10.8447 10.7826 11.0364 10.6392 11.2574 10.5628C11.4783 10.4864 11.7176 10.4808 11.9419 10.5466C12.1662 10.6125 12.3645 10.7466 12.5091 10.9303C13.0805 10.6308 13.7195 10.4838 14.3643 10.5034C15.0092 10.5231 15.6381 10.7088 16.1901 11.0426C16.7422 11.3764 17.1989 11.847 17.5159 12.4088C17.833 12.9707 17.9997 13.6049 18 14.25V16.5C18 16.7984 17.8815 17.0845 17.6705 17.2955C17.4595 17.5065 17.1734 17.625 16.875 17.625C16.5766 17.625 16.2905 17.5065 16.0795 17.2955C15.8685 17.0845 15.75 16.7984 15.75 16.5V14.25C15.75 13.8522 15.592 13.4706 15.3107 13.1893C15.0294 12.908 14.6478 12.75 14.25 12.75C13.8522 12.75 13.4706 12.908 13.1893 13.1893C12.908 13.4706 12.75 13.8522 12.75 14.25V16.5C12.75 16.7984 12.6315 17.0845 12.4205 17.2955C12.2095 17.5065 11.9234 17.625 11.625 17.625C11.3266 17.625 11.0405 17.5065 10.8295 17.2955C10.6185 17.0845 10.5 16.7984 10.5 16.5ZM9 11.625V16.5C9 16.7984 8.88147 17.0845 8.6705 17.2955C8.45952 17.5065 8.17337 17.625 7.875 17.625C7.57663 17.625 7.29048 17.5065 7.0795 17.2955C6.86853 17.0845 6.75 16.7984 6.75 16.5V11.625C6.75 11.3266 6.86853 11.0405 7.0795 10.8295C7.29048 10.6185 7.57663 10.5 7.875 10.5C8.17337 10.5 8.45952 10.6185 8.6705 10.8295C8.88147 11.0405 9 11.3266 9 11.625ZM6.375 7.5C6.375 7.20333 6.46297 6.91332 6.6278 6.66665C6.79262 6.41997 7.02689 6.22771 7.30097 6.11418C7.57506 6.00065 7.87666 5.97094 8.16764 6.02882C8.45861 6.0867 8.72588 6.22956 8.93566 6.43934C9.14544 6.64912 9.2883 6.91639 9.34618 7.20736C9.40406 7.49834 9.37435 7.79994 9.26082 8.07403C9.14729 8.34811 8.95503 8.58238 8.70835 8.7472C8.46168 8.91203 8.17167 9 7.875 9C7.47718 9 7.09564 8.84196 6.81434 8.56066C6.53304 8.27936 6.375 7.89782 6.375 7.5Z'
              fill='#3182FF'
            />
          </svg>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            id='worksDetail-share-instagram'>
            <path
              d='M12 7.5C11.11 7.5 10.24 7.76392 9.49993 8.25839C8.75991 8.75285 8.18314 9.45566 7.84254 10.2779C7.50195 11.1002 7.41283 12.005 7.58647 12.8779C7.7601 13.7508 8.18868 14.5526 8.81802 15.182C9.44736 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0243 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25ZM16.5 1.875H7.5C6.00869 1.87674 4.57896 2.46993 3.52444 3.52444C2.46993 4.57896 1.87674 6.00869 1.875 7.5V16.5C1.87674 17.9913 2.46993 19.421 3.52444 20.4756C4.57896 21.5301 6.00869 22.1233 7.5 22.125H16.5C17.9913 22.1233 19.421 21.5301 20.4756 20.4756C21.5301 19.421 22.1233 17.9913 22.125 16.5V7.5C22.1233 6.00869 21.5301 4.57896 20.4756 3.52444C19.421 2.46993 17.9913 1.87674 16.5 1.875ZM19.875 16.5C19.875 17.3951 19.5194 18.2535 18.8865 18.8865C18.2535 19.5194 17.3951 19.875 16.5 19.875H7.5C6.60489 19.875 5.74645 19.5194 5.11351 18.8865C4.48058 18.2535 4.125 17.3951 4.125 16.5V7.5C4.125 6.60489 4.48058 5.74645 5.11351 5.11351C5.74645 4.48058 6.60489 4.125 7.5 4.125H16.5C17.3951 4.125 18.2535 4.48058 18.8865 5.11351C19.5194 5.74645 19.875 6.60489 19.875 7.5V16.5ZM18.375 7.125C18.375 7.42167 18.287 7.71168 18.1222 7.95835C17.9574 8.20503 17.7231 8.39729 17.449 8.51082C17.1749 8.62435 16.8733 8.65406 16.5824 8.59618C16.2914 8.5383 16.0241 8.39544 15.8143 8.18566C15.6046 7.97588 15.4617 7.70861 15.4038 7.41764C15.3459 7.12666 15.3756 6.82506 15.4892 6.55097C15.6027 6.27689 15.795 6.04262 16.0416 5.8778C16.2883 5.71297 16.5783 5.625 16.875 5.625C17.2728 5.625 17.6544 5.78304 17.9357 6.06434C18.217 6.34564 18.375 6.72718 18.375 7.125Z'
              fill='#3182FF'
            />
          </svg>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            id='worksDetail-share-twitter'>
            <path
              d='M23.54 6.32012C23.4549 6.11446 23.3106 5.93868 23.1256 5.81502C22.9405 5.69136 22.7229 5.62538 22.5003 5.62543H19.8584C19.4144 4.94195 18.8082 4.37887 18.094 3.98631C17.3797 3.59375 16.5794 3.3839 15.7644 3.37543C15.1285 3.36689 14.4973 3.48567 13.9081 3.72476C13.3188 3.96385 12.7833 4.31843 12.3331 4.76762C11.8702 5.22163 11.5028 5.76364 11.2524 6.36176C11.002 6.95988 10.8738 7.60203 10.8753 8.25043V8.32355C7.4225 7.23887 4.65218 4.48918 4.62218 4.45824C4.47123 4.30612 4.27997 4.20028 4.07091 4.15317C3.86184 4.10606 3.64367 4.11965 3.44207 4.19234C3.24046 4.26502 3.06381 4.39378 2.9329 4.56345C2.802 4.73313 2.72227 4.93667 2.70312 5.15012C2.11156 11.7286 5.01406 15.2554 6.64625 16.6926C5.28781 18.0782 3.37531 18.8142 3.35656 18.8217C3.19755 18.8809 3.05398 18.9753 2.93661 19.0978C2.81924 19.2203 2.7311 19.3678 2.6788 19.5292C2.6265 19.6906 2.61139 19.8618 2.6346 20.0299C2.6578 20.198 2.71873 20.3586 2.81281 20.4998C3.00031 20.7707 4.07281 22.1254 7.50031 22.1254C14.2737 22.1254 19.9409 16.9448 20.5878 10.2539L23.2953 7.54637C23.4528 7.3891 23.5602 7.18865 23.6037 6.97037C23.6473 6.75209 23.6251 6.52579 23.54 6.32012ZM18.7053 8.95543C18.5114 9.14852 18.395 9.40602 18.3781 9.67918C18.0134 15.397 13.2359 19.8754 7.50031 19.8754C7.10876 19.8777 6.71752 19.853 6.32937 19.8014C7.31281 19.177 8.41156 18.2882 9.18781 17.1248C9.27272 16.9974 9.33075 16.8541 9.35835 16.7035C9.38594 16.553 9.38252 16.3984 9.34829 16.2492C9.31407 16.1 9.24975 15.9593 9.15929 15.8359C9.06883 15.7124 8.95412 15.6087 8.82218 15.5311C8.81093 15.5245 7.66625 14.8289 6.62562 13.2417C5.585 11.6545 5.0075 9.77293 4.895 7.6373C6.50375 8.85043 9.00031 10.387 11.8128 10.8604C11.9742 10.8877 12.1396 10.8794 12.2974 10.8362C12.4553 10.793 12.6018 10.7158 12.7268 10.6102C12.8517 10.5045 12.9521 10.3728 13.021 10.2243C13.0898 10.0758 13.1254 9.9141 13.1253 9.75043V8.25043C13.1245 7.90006 13.1939 7.55307 13.3293 7.22992C13.4647 6.90677 13.6634 6.614 13.9137 6.36887C14.1528 6.12971 14.4373 5.94075 14.7504 5.81308C15.0636 5.68541 15.399 5.62161 15.7372 5.62543C16.2484 5.63227 16.7472 5.78398 17.1757 6.06293C17.6041 6.34188 17.9447 6.73663 18.1578 7.20137C18.2455 7.40184 18.3898 7.57239 18.573 7.69211C18.7561 7.81184 18.9702 7.87554 19.1891 7.87543H19.7816L18.7053 8.95543Z'
              fill='#3182FF'
            />
          </svg>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            id='worksDetail-share-facebook'>
            <path
              d='M12 1.875C9.99747 1.875 8.0399 2.46882 6.37486 3.58137C4.70981 4.69392 3.41206 6.27523 2.64572 8.12533C1.87939 9.97543 1.67888 12.0112 2.06955 13.9753C2.46023 15.9393 3.42454 17.7435 4.84055 19.1595C6.25656 20.5755 8.06066 21.5398 10.0247 21.9305C11.9888 22.3211 14.0246 22.1206 15.8747 21.3543C17.7248 20.5879 19.3061 19.2902 20.4186 17.6251C21.5312 15.9601 22.125 14.0025 22.125 12C22.122 9.3156 21.0543 6.74199 19.1562 4.84383C17.258 2.94567 14.6844 1.87798 12 1.875ZM13.125 19.7934V14.625H15C15.2984 14.625 15.5845 14.5065 15.7955 14.2955C16.0065 14.0845 16.125 13.7984 16.125 13.5C16.125 13.2016 16.0065 12.9155 15.7955 12.7045C15.5845 12.4935 15.2984 12.375 15 12.375H13.125V10.5C13.125 10.2016 13.2435 9.91548 13.4545 9.7045C13.6655 9.49353 13.9516 9.375 14.25 9.375H15.75C16.0484 9.375 16.3345 9.25647 16.5455 9.0455C16.7565 8.83452 16.875 8.54837 16.875 8.25C16.875 7.95163 16.7565 7.66548 16.5455 7.4545C16.3345 7.24353 16.0484 7.125 15.75 7.125H14.25C13.3549 7.125 12.4965 7.48058 11.8635 8.11351C11.2306 8.74645 10.875 9.60489 10.875 10.5V12.375H9C8.70164 12.375 8.41549 12.4935 8.20451 12.7045C7.99353 12.9155 7.875 13.2016 7.875 13.5C7.875 13.7984 7.99353 14.0845 8.20451 14.2955C8.41549 14.5065 8.70164 14.625 9 14.625H10.875V19.7934C8.90447 19.509 7.1148 18.4888 5.86617 16.938C4.61755 15.3873 4.00265 13.4211 4.14522 11.4353C4.2878 9.44942 5.17727 7.59128 6.63463 6.23481C8.09198 4.87833 10.009 4.12421 12 4.12421C13.991 4.12421 15.908 4.87833 17.3654 6.23481C18.8227 7.59128 19.7122 9.44942 19.8548 11.4353C19.9974 13.4211 19.3825 15.3873 18.1338 16.938C16.8852 18.4888 15.0955 19.509 13.125 19.7934Z'
              fill='#3182FF'
            />
          </svg>
        </div>
      </div>
      <div className='right'>
        <img
          src='https://assets.materialup.com/uploads/28b7af29-c8e1-4f4d-b5fd-8d797bb00e6a/preview.png'
          alt='work-preview'
          id='worksDetail-projectImage-1'
        />
      </div>
    </WorkDetailPagesSectionOneStyled>
  );
};

const WorkDetailPagesSectionOneStyled = styled.div`
  padding: 80px 0px;
  display: flex;
  align-items: center;
  gap: 42px;
  .left {
    width: 40%;
    .breadcrumb-container {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      .first {
        color: var(--primary-base);
      }
      .second {
        color: var(--hxvr-neutral-70);
      }
    }
    .project-title {
      margin-bottom: 24px;
    }
    .desc-container {
      color: var(--hxvr-neutral-secondary);
      margin-bottom: 24px;
    }
    .tagging {
      display: flex;
      align-items: flex-start;
      gap: 32px;
      justify-content: space-between;
      margin-bottom: 24px;
      .tag-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .tag-work {
        .bottom {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          flex-wrap: wrap;
        }
      }
    }
    .media-sosial {
      display: flex;
      gap: 16px;
      svg {
        cursor: pointer;
      }
    }
  }

  .right {
    width: 60%;
    img {
      width: 100%;
      border-radius: 12px;
      object-fit: cover;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 0px;
    display: flex;
    flex-direction: column;
    .left {
      width: 100%;
    }

    .right {
      width: 100%;
    }
  }
`;

export default WorkDetailPagesSectionOne;
